'use client';

import { LanguageSwitcher } from '@/components/LanguageSwitcher';
import { NavigationModal } from '@/components/NavigationModal';
import { EclipseCountdownCompact } from '@/components/EclipseCountdownCompact';

interface TopBarProps {
  title?: string;
  showHomeButton?: boolean;
}

export function TopBar({
  title,
  showHomeButton = true
}: TopBarProps) {
  return (
    <header className="border-b sticky top-0 z-50 bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/60">
      <div className="max-w-7xl mx-auto px-4 py-3">
        <div className="flex items-center justify-between">
          {/* Left: Language Switcher */}
          <div className="flex items-center">
            <LanguageSwitcher />
          </div>

          {/* Center: Eclipse Countdown */}
          <div className="flex items-center">
            <EclipseCountdownCompact />
          </div>

          {/* Right: Navigation Modal */}
          <div className="flex items-center">
            <NavigationModal />
          </div>
        </div>
      </div>
    </header>
  );
}
